<template>
  <div class="createPlayStep new-input-box" v-loading="loading">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-back
        @back="returnBack()"
        :title="['互动广场']"
        :subTitle="activityData.name"
        style="padding-bottom: 0"
      ></jd-back>
    </div>
    <div class="formBox">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 活动条件表单设置 -->
      <div class="secondstep" v-if="localStepNum == 0 || localStepNum == 1">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          class="backgroundForm"
          label-width="150px"
        >
          <!-- 基本信息 -->
          <informationForm
            @selectPeopleSure="selectPeopleSure"
            @getMemberFn="resetMemberFn"
            :defaultActMember.sync="actMember"
            :defaultActivityStartTime.sync="activityStartTime"
            :defaultActivityEndTime.sync="activityEndTime"
            :plusObject.sync="ruleDTO.plusObject"
            :openCardStartTime.sync="ruleDTO.openCardStartTime"
            :openCardEndTime.sync="ruleDTO.openCardEndTime"
            :peopleSelected.sync="peopleSelected"
            ref="informationForm"
            v-model="ruleForm"
            :isEdit="false"
            :disabled="activityData.isStart"
            :localStepNum="localStepNum"
            :needNonMember="false"
            :activityId="80"
            :showOpenCardTip="true"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          >
          </informationForm>
          <!-- 活动设置 -->
          <jd-title label="晒单设置"></jd-title>
          <div class="mt20">
            <el-form-item required label="晒单设置:">
              <jd-button type="blueLine" @click="addContent"
                >添加内容</jd-button
              >
              <contentCom
                class="mt16"
                v-if="shareContentList.length > 0"
                :tableInfo="tableInfo"
                :tableData.sync="shareContentList"
                :isShowEditBtn="true"
                @edit="editContentFn"
              />
            </el-form-item>
            <el-form-item required label="展示顺序:">
              <el-radio-group
                v-model="ruleDTO.displaySequence"
                :disabled="activityData.isStart"
              >
                <el-radio :label="0">根据顺序展示晒单内容</el-radio>
                <el-radio :label="1">随机展示晒单内容</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              required
              label="展示数量:"
              v-if="ruleDTO.displaySequence == 1"
            >
              <span>用户随机可选择</span>
              <el-input
                class="w125 mlr8"
                v-model="ruleDTO.displayNum"
                @input="ruleDTO.displayNum = handleShowNum($event)"
                :disabled="activityData.isStart"
                placeholder="请输入"
              />
              <span>组晒单内容</span>
            </el-form-item>
            <el-form-item
              required
              label="晒单条件:"
              :disabled="activityData.isStart"
            >
              <el-radio-group
                v-model="ruleDTO.showProductType"
                :disabled="activityData.isStart"
              >
                <el-radio :label="0">直接分享</el-radio>
                <el-radio :label="1">下单后分享</el-radio>
              </el-radio-group>
              <div class="order-box" v-if="ruleDTO.showProductType == 1">
                <el-form-item label="下单店铺:" required>
                  <orderShopCom
                    :venderIds.sync="ruleDTO.venderIds"
                    :multiShopGoods.sync="multiShopGoods"
                    :sellerSkuList.sync="ruleDTO.sellerSkuList"
                    :isDisabled="activityData.isStart"
                  />
                </el-form-item>
                <el-form-item label="下单时间:" required>
                  <span class="mr8">用户在</span>
                  <div class="my_select_time">
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="ruleDTO.orderStartTime"
                      type="datetime"
                      placeholder="选择日期时间"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 185px; font-size: 12px"
                      class="time1"
                      :clearable="false"
                      :disabled="activityData.isStart"
                    >
                    </el-date-picker>
                    <div class="time_to_text">至</div>
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="ruleDTO.orderEndTime"
                      default-time="23:59:59"
                      type="datetime"
                      placeholder="选择日期时间"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 185px; font-size: 12px"
                      class="time2"
                      :clearable="false"
                      :picker-options="orderEndPickerOptions"
                      :disabled="activityData.isStart || !ruleForm.endTime"
                    >
                    </el-date-picker>
                    <i
                      class="el-icon-circle-close date_icon1"
                      v-if="!activityData.isStart"
                      @click="clearOrderTime"
                    ></i>
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                      alt=""
                      class="date_icon2"
                    />
                  </div>
                  <span class="ml8">期间内下单</span>
                </el-form-item>
                <el-form-item label="金额统计类型:" required>
                  <el-radio-group
                    v-model="ruleDTO.orderPaymentType"
                    :disabled="activityData.isStart"
                  >
                    <el-radio :label="1">
                      <span>订单金额（后台价）</span>
                      <el-tooltip class="item" effect="dark" content="是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。" placement="top-start">
                        <div class="new-icon-box" style="margin: -3px 8px"></div>
                      </el-tooltip>
                    </el-radio>
                    <el-radio :label="0" v-if="!isVenderType">
                      <span>用户应付金额</span>
                      <el-tooltip class="item" effect="dark" content="订单商品原价总额-订单优惠总额+订单运费+税费+调整运费金额=用户应付金额" placement="top-start">
                        <div class="new-icon-box" style="margin: -3px 8px"></div>
                      </el-tooltip>
                    </el-radio>
                    <el-radio :label="2" v-if="!isVenderType">
                      <span>用户实付金额</span>
                      <el-tooltip class="item" effect="dark" content="用户应付金额-支付优惠总额=用户实付金额" placement="top-start">
                        <div class="new-icon-box" style="margin: -3px 8px"></div>
                      </el-tooltip>
                    </el-radio>
                  </el-radio-group>
                  <div style="color: red">
                    注意：由于接口原因，自营仅支持统计订单金额，pop可按需选择统计实付金额或订单金额。
                  </div>
                </el-form-item>
                <el-form-item label="商品要求:" required>
                  <!-- <el-radio-group
                    v-model="ruleDTO.filterType"
                    :disabled="activityData.isStart"
                    @change="filterTypeChange"
                  >
                    <el-radio :label="0">全部</el-radio>
                    <el-radio :label="1">指定商品</el-radio>
                    <el-radio :label="2">排除商品</el-radio>
                  </el-radio-group>
                  <jd-button
                    @click="exposureProducts"
                    :disabled="ruleDTO.filterType == 0 || activityData.isStart"
                    class="ml8"
                  >
                    已选{{ specifiedGoods.length }}个
                  </jd-button> -->
                  <productReqCom
                    :filterType.sync="ruleDTO.filterType"
                    :venderIds.sync="ruleDTO.venderIds"
                    :sellerSkuList.sync="ruleDTO.sellerSkuList"
                    :multiShopGoods.sync="multiShopGoods"
                    :isCreated="isCreated" 
                    :isDisabled="activityData.isStart"
                    :backgroundOpacity="backgroundOpacity"
                    @changeFilterType="filterTypeChange"
                  />
                </el-form-item>
                <el-form-item label="指定商品规则:" v-if="ruleDTO.orderPaymentType==1&&ruleDTO.filterType == 1">
                  <el-select style="width: 280px;" v-model="ruleDTO.filterSkuType" :disabled="activityData.isStart" placeholder="">
                    <el-option label="只要订单包含指定商品就整单计算" :value="0"></el-option>
                    <el-option label="仅统计订单内指定商品的金额和件数" :value="1"></el-option>
                  </el-select>
                  <jd-button type="blueText" class="ml12" @click="viewStatisticsLogic">查看统计逻辑</jd-button>
                </el-form-item>
                <el-form-item label="商品件数:">
                  <el-input
                    v-model="ruleDTO.itemLimitCount"
                    @input="
                      ruleDTO.itemLimitCount = getNumberData(
                        1,
                        $event,
                        0,
                        1,
                        999999
                      )
                    "
                    style="width: 140px"
                    placeholder="请输入"
                    :disabled="activityData.isStart"
                  ></el-input>
                  <span class="ml8">件及以上</span>
                </el-form-item>
                <el-form-item label="订单金额:" required>
                  <el-input
                    v-model="ruleDTO.orderPaymentLimit"
                    @input="
                      ruleDTO.orderPaymentLimit = getNumberData(1, $event, 1, 0)
                    "
                    style="width: 140px"
                    placeholder="请输入"
                    :disabled="activityData.isStart"
                  ></el-input
                  ><span class="ml8">元及以上</span>
                </el-form-item>
                <el-form-item label="订单拆单后是否合并:" label-width="160px" required>
                  <el-radio-group
                    :disabled="activityData.isStart"
                    v-model="ruleDTO.mergeOrder"
                  >
                    <el-radio :label="false">否</el-radio>
                    <el-radio :label="true">是</el-radio>
                  </el-radio-group>
                  <jd-button type="blueText" class="ml12" @click="viewMergeLogic">查看合并拆单逻辑</jd-button>
                </el-form-item>
                <el-form-item label="订单状态:" required>
                  <el-radio-group
                    :disabled="activityData.isStart"
                    v-model="ruleDTO.orderType"
                  >
                    <el-radio :label="1">已完成</el-radio>
                    <!-- <el-radio :label="1"
                      >已付款（下单付款后即可统计（预售商品需要支付尾款才统计））</el-radio
                    > -->
                  </el-radio-group>
                </el-form-item>
              </div>
            </el-form-item>
          </div>
          <!-- 奖品设置 -->
          <jd-title label="奖品设置"></jd-title>
          <div class="mt20">
            <el-form-item label="活动类型:">
              <el-radio-group
                v-model="ruleDTO.activityType"
                :disabled="activityData.isStart"
                @change="activityTypeChange"
              >
                <el-radio :label="0">晒单抽奖</el-radio>
                <el-radio :label="1">晒单领奖</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="奖品设置:">
              <div v-if="ruleDTO.activityType == 0">
                <lotteryPrize
                  isShowLimit
                  :dailyLimitDisabled="!backgroundOpacity"
                  :prizeSettingList.sync="lotteryPrizeList"
                  :activityData="activityData"
                  :valueRow="valueRow"
                  :backgroundOpacity="backgroundOpacity"
                  :isDisabled="activityData.isStart"
                  :isShowLottery="false"
                  :isShowAddBtn="true"
                  :isCustomizeTip="true"
                  :isShowDeleteBtn="true"
                  :isShowTip="true"
                  :addPrizeText="addPrizeText"
                  :minLimit="minLimit"
                  :actType="80"
                  :actEndTime="ruleForm.endTime"
                  @addPrizeSetting="addSettingList"
                >
                  <template #tipText>
                    <div>
                      注：所有奖品中奖率相加不得大于100%，如某一奖品库存空时，概率自动分配为【谢谢参与】
                    </div>
                  </template>
                </lotteryPrize>
              </div>
              <div v-else>
                <newPrizeTable
                  :prizeList.sync="claimPrizeList"
                  :isDisabled="activityData.isStart"
                  :tableInfo="prizeInfo"
                  :valueRow="valueRow"
                  :isIndex="false"
                  :isShowUpLoadBtn="true"
                  :isShowAdd="true"
                  :addText="addText"
                  :maxPrizeCount="maxPrizeCount"
                  :actType="80"
                  :actEndTime="ruleForm.endTime"
                  @addPrize="addPrize"
                >
                  <template #dailyLimitName="{ scopeRow }">
                    <dailyLimitConfig
                      :row="scopeRow"
                      :backgroundOpacity="backgroundOpacity"
                      :limitBtnDisabled="backgroundOpacity"
                    ></dailyLimitConfig>
                  </template>
                </newPrizeTable>
              </div>
            </el-form-item>
            <el-form-item label="领奖时间提醒:">
              <el-checkbox v-model="ruleDTO.remindToCheck" @change="changeRemind" :disabled="activityData.isStart" :true-label="1" :false-label="0">
                <span>用户完成晒单后，订阅时间提醒查看审核结果，</span>
                <span>商家需自行确保完成审核否则客户可能订阅时间后查看活动显示未审核</span>
              </el-checkbox>
              <div class="remind-box" v-if="ruleDTO.remindToCheck==1">
                <el-form-item label="提醒时间:" required label-width="auto">
                  <span>客户提交晒单</span>
                  <el-input
                    v-model="ruleDTO.remindDayNum"
                    @input="
                      ruleDTO.remindDayNum = getNumberData(
                        1,
                        $event,
                        0,
                        1
                      )
                    "
                    class="w125 mlr8"
                    placeholder="请输入"
                    :disabled="activityData.isStart"
                  ></el-input>
                  <span>天后提醒（固定每日早8点提醒）</span>
                </el-form-item>
                <el-form-item label="周末不提示:" label-width="auto">
                  <el-checkbox v-model="ruleDTO.weekendNotRemind" :disabled="activityData.isStart" :true-label="1" :false-label="0">
                    客户周六、周日提交后，需周二才提醒
                  </el-checkbox>
                </el-form-item>
              </div>
            </el-form-item>
          </div>
          <!-- 活动页设置 -->
          <activityPageSettings
            isShowShopName
            isShowShopNameByChannel
            isShowMoreSet
            :cusTemplateJSON.sync="ruleDTO.cusTemplateJSON"
            :isNeedSetBG="true"
            :giftList="giftList"
            :templateId="templateId"
            :isShowDesignNumber="false"
            previewKey="url"
            templatekey="imageUrl"
            :widthNumber="750"
            :heightNumber="2380"
            :isCustomPreview="true"
            :downloadTemplateUrl="templateUrl"
            designSpecificationsUrl="https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/xhs-order-design.png"
            themeTitle="主题"
            :defaultRgb="currrentRgb"
            v-model="customerPaperwork"
            @selectTemplate="selectTemplate"
          >
            <template #customPreview>
              <xhsSunGiftDialog
                :ruleForm="ruleForm"
                :ruleDTO="ruleDTO"
                :backgroundImage="backgroundImage"
                :customerPaperwork="customerPaperwork"
                :templateObj="templateObj"
                :shareContentList="shareContentList"
                :productList="commonPrizeList"
              />
            </template>
            <template #otherSet>
              <!-- 自定义活动页设置 -->
              <el-form-item label="按钮设置:">
                <div class="upload-box">
                  <el-form-item label="按钮背景图：" label-width="130px">
                    <div class="buttonGroup">
                      <el-upload
                        class="upload"
                        action="/jd-hd-web/image/upload"
                        :show-file-list="false"
                        :before-upload="(file) => beforeUploadUI(file, 1)"
                        :on-success="(res) => handleUploadUI(res, 1)"
                      >
                        <div class="bg-wrap" v-if="customerPaperwork.url2">
                          <img
                            :src="customerPaperwork.url2"
                            class="bg-wrap-img"
                          />
                        </div>
                        <jd-button
                          v-else
                          type="blueLine"
                          label="自定义上传"
                          :disabled="backgroundOpacity"
                        ></jd-button>
                      </el-upload>
                      <jd-button
                        type="blueText"
                        @click="customerPaperwork.url2 = ''"
                        class="ml16"
                        :disabled="backgroundOpacity"
                        >重置</jd-button
                      >
                      <span class="size-tip">尺寸建议：350*88px</span>
                    </div>
                  </el-form-item>
                  <el-form-item label="按钮文案颜色：" label-width="130px">
                    <div class="flexc-cen-x">
                      <el-color-picker
                        v-model="customerPaperwork.btnColor"
                        :disabled="backgroundOpacity"
                        class="colorPicker"
                      >
                      </el-color-picker>
                      <jd-button
                        class="ml16"
                        type="blueText"
                        :disabled="backgroundOpacity"
                        @click="customerPaperwork.btnColor = currrentRgb2"
                        >重置</jd-button
                      >
                    </div>
                  </el-form-item>
                </div>
              </el-form-item>
              <el-form-item label="文案颜色：">
                <div class="flexc-cen-x">
                  <el-color-picker
                    v-model="customerPaperwork.textColor"
                    :disabled="backgroundOpacity"
                    class="colorPicker"
                  >
                  </el-color-picker>
                  <jd-button
                    class="ml16"
                    type="blueText"
                    :disabled="backgroundOpacity"
                    @click="customerPaperwork.textColor = currrentRgb3"
                    >重置</jd-button
                  >
                </div>
              </el-form-item>
              <el-form-item label="奖品背景颜色：">
                <div class="flexc-cen-x">
                  <el-color-picker
                    v-model="customerPaperwork.prizeBgColor"
                    :disabled="backgroundOpacity"
                    class="colorPicker"
                  >
                  </el-color-picker>
                  <jd-button
                    class="ml16"
                    type="blueText"
                    :disabled="backgroundOpacity"
                    @click="customerPaperwork.prizeBgColor = currrentRgb4"
                    >重置</jd-button
                  >
                </div>
              </el-form-item>
            </template>
          </activityPageSettings>
          <jd-title label="进店设置" type="bold"></jd-title>
          <el-form-item label="进店逛逛:">
            <el-radio-group
              v-model="ruleDTO.goShopSetting"
              :disabled="activityData.isStart"
              @change="onShopSetChange"
            >
              <el-radio :label="0">进入店铺首页</el-radio>
              <el-radio :label="1">跳转指定小程序</el-radio>
              <el-radio :label="2">进入指定链接</el-radio>
            </el-radio-group>
            <div style="color: #f56c6c">
              部分活动需要配合曝光商品使用，如幸运抽奖、裂变神券
            </div>
          </el-form-item>
          <div v-if="ruleDTO.goShopSetting == 1">
            <el-form-item label="小程序appId:" required>
              <el-input
                type="textarea"
                placeholder="请输入小程序appId"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleDTO.goShopAppId"
                :maxlength="1000"
                :disabled="activityData.isStart"
              ></el-input>
            </el-form-item>
            <el-form-item label="页面路径path:">
              <el-input
                type="textarea"
                placeholder="请输入小程序页面路径path"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleDTO.goShopUrl"
                :maxlength="1000"
                :disabled="activityData.isStart"
              ></el-input>
              <div style="color: #f56c6c">
                注意：path若不写，则默认进入小程序主页。
              </div>
            </el-form-item>
          </div>
          <el-form-item
            label="指定链接:"
            required
            v-if="ruleDTO.goShopSetting == 2"
          >
            <el-input
              type="textarea"
              placeholder="请输入指定链接"
              style="width: 425px; margin-left: 8px"
              show-word-limit
              v-model="ruleDTO.goShopUrl"
              :maxlength="1000"
              :disabled="activityData.isStart"
            ></el-input>
            <div style="color: #f56c6c">
              注意：仅可填写京东域内的
              H5页面地址，不可设置外链。参考链接：https://m.jd.com/。
            </div>
          </el-form-item>
          <exposureList
            :defaultExposureSwitch.sync="ruleForm.isExposureItem"
            v-model="itemListFor"
            :backgroundOpacity="backgroundOpacity"
            :isLimit="true"
            :isEdit="isCreated" 
            :multiShopSkuType.sync="multiShopSkuType" 
            :multiShopGoods="multiShopGoods" 
            :skuBelongVenderId="skuBelongVenderId"
          ></exposureList>
          <sharFrom :sharePic="sharePic" v-model="ruleDTO"></sharFrom>
          <activityRules
            :isForceRemind.sync="isForceRemind"
            :isKeyActivity.sync="isKeyActivity"
            :placementPosition.sync="placementPosition"
            v-model="ruleForm.ruleDescription"
            @generateRule="generateRule"
            :activityData="activityData"
            :valueRow="valueRow"
          ></activityRules>
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStepNum == 0 || localStepNum == 1">
      <jd-button
        v-if="localStepNum != 0"
        style="margin-right: 8px"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn"
        >保存至草稿箱</jd-button
      >
      <template v-if="!backgroundOpacity">
        <jd-button v-if="isSave" type="blue" @click="resetForm" v-preventReClick
          >保存设置</jd-button
        >
      </template>
    </div>

    <!-- 保存设置弹框 -->
    <el-dialog
      title="重要提示"
      :visible.sync="joinBlackList"
      width="800"
      @close="checked = false"
    >
      <div v-loading="saveLoading">
        <div style="line-height: 25px; margin-bottom: 30px">
          <p>
            1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
          </p>
          <p>
            2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
          </p>
        </div>

        <el-checkbox v-model="checked" label="地址" name="partner"
          >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
        >
      </div>
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取 消</jd-button>
        <jd-button
          @click="handleDialogCloseAnoth()"
          type="blue"
          style="margin-left: 8px"
          v-loading="saveLoading"
          >确 定</jd-button
        >
      </div>
    </el-dialog>
    <addContentDialog
      :isShow.sync="isShowDialog"
      :isEdit="isEdit"
      :editData="editData"
      :shareContentList="shareContentList"
      v-if="isShowDialog"
      @submitForm="saveForm"
    />
    <!-- 指定购买商品 -->
    <selectGoodsMonitor
      v-if="isShowGoods"
      :isShow="isShowGoods"
      @close="selectGoodsClose"
      :selectGoods="specifiedGoods"
      :moduleType="true"
      :skuSearch="true"
      :xianz="false"
      :disabled="backgroundOpacity"
    ></selectGoodsMonitor>
  </div>
</template>

<script>
import {
  saveOrUpdateXhsShowProduct,
  getXhsShowProductDetail,
} from "@/api/jhk/integralCenter/PointActivityAnalyticController.js";
import { sellerImage } from "@/api/jhk/paradiseAndTaskCommonController.js";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import informationForm from "../components/informationForm.vue";
import exposureList from "../components/exposureList.vue";
import sharFrom from "../components/sharFrom.vue";
import activityRules from "../components/activityRules.vue";
import activityPageSettings from "../components/activityPageSettings.vue";
import xhsSunGiftDialog from "../components/newActPreviews/xhsSunGift/xhs-sunGift-dialog.vue";
import addContentDialog from "./components/addContentDialog.vue";
import contentCom from "@/views/interactiveMarketing/activity/xhsSunGift/components/contentCom.vue";
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import lotteryPrize from "../components/lotteryPrize/index.vue";
import newPrizeTable from "../components/newPrizeTable/index.vue";
import { getTaobaoItemListSku } from "@/api/jhk/analysis/ware-controller";
import dailyLimitConfig from "@/views/interactiveMarketing/activity/components/dailyLimitConfig.vue";
import orderShopCom from "@/views/interactiveMarketing/activity/components/multipleStoreSetting/orderShopCom.vue";
import productReqCom from "@/views/interactiveMarketing/activity/components/multipleStoreSetting/productReqCom.vue";
import { useValidateMultiShopGoods,useValidateMoreActSet } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";
export default {
  components: {
    informationForm,
    exposureList,
    sharFrom,
    activityRules,
    activityPageSettings,
    xhsSunGiftDialog,
    addContentDialog,
    contentCom,
    selectGoodsMonitor,
    lotteryPrize,
    newPrizeTable,
    dailyLimitConfig,
    orderShopCom,
    productReqCom,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    valueRow: {
      type: Object,
      default: () => {},
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCreated: false,
      multiShopSkuType: 0,
      skuBelongVenderId: "",
      multiShopGoods: [],
      minLimit: 1,
      addPrizeText: "+添加奖品",
      maxPrizeCount: 20,
      addText: "+添加奖品",
      prizeInfo: [
        {
          label: "奖品类型",
          prop: "prizeType",
          slot: "prizeTypeSlot",
          minWidth: 100,
        },
        {
          label: "值",
          prop: "price",
          minWidth: 100,
        },
        {
          label: "奖品名称（12字以内）",
          prop: "title",
          slot: "titleSlot",
          slotHead: "titleHeader",
          minWidth: 200,
        },
        {
          label: "奖品数量",
          prop: "totalAmount",
          slot: "totalAmountSlot",
          minWidth: 120,
        },
        {
          label: "每日发放限额",
          slotName: "dailyLimitName",
          slot: "dailyLimit",
          width: 120,
        },
        {
          label: "图片",
          prop: "logo",
          slot: "logoSlot",
          minWidth: 120,
        },
        {
          label: "操作",
          minWidth: "90px",
          prop: "operation",
          slot: "operationSlot",
          minWidth: 142,
        },
      ],
      claimPrizeList: [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          singleAmount: "",
          prizeObjectType: 0,
        },
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          singleAmount: "",
          prizeObjectType: 0,
        },
      ],
      lotteryPrizeList: [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: null,
          price: null,
          title: "",
          totalAmount: null,
          percentage: null,
          logo: "",
          prizeObjectType: 0,
        },
      ],
      isShowGoods: false,
      editData: null,
      currentIndex: -1,
      isEdit: false,
      isShowDialog: false,
      shareContentList: [],
      isLimit: true,
      tableInfo: [
        {
          label: "排序",
          slot: "sortSlot",
          minWidth: 120,
        },
        {
          label: "分享图",
          slot: "urlSlot",
          minWidth: 180,
        },
        {
          label: "分享正文",
          prop: "shareContext",
          type: "scalable",
          minWidth: 180,
        },
        // {
        //   label: "分享内容来源",
        //   prop: "shareContentSource",
        //   slot: "shareContentSourceSlot",
        //   minWidth: 180,
        // },
        {
          label: "操作",
          slot: "operationSlot",
          minWidth: 160,
        },
      ],
      isKeyActivity: 0,
      placementPosition: [],
      isForceRemind: 0,
      templateUrl:
        "https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/%E5%B0%8F%E7%BA%A2%E4%B9%A6%E6%99%92%E5%8D%95%E7%A4%BC%E6%A8%A1%E6%9D%BF.psd",
      saveLoading: false,
      loading: false,
      templateObj: {},
      currrentRgb: "",
      currrentRgb2: "",
      currrentRgb3: "",
      currrentRgb4: "",
      customerPaperwork: {
        title: "小红书晒单礼",
        desc: "一键分享小红书，得惊喜好礼",
        titleColor: "#ffffff",
        url2: "", //按钮背景图
        btnColor: "#ffffff", //按钮文案颜色
        textColor: "#ffffff", //文案颜色
        prizeBgColor: "#ffffff", //奖品背景颜色
      },
      actMember: "1",
      peopleSelected: [],
      templateId: "",
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      giftList: [],
      itemListFor: [], //商品弹框选择商品数据
      joinBlackList: false,
      checked: false,
      localStepNum: this.stepNum, // 将外部传入的步骤赋值到本地，避免直接更改props
      ruleForm: {
        assetsId: "",
        startTime: "",
        endTime: "",
        condFollow: false,
        ruleDescription: "",
        partner: ["-1"],
        allowLevel: "-1",
        activityName: "",
        openCardFollow: 0,
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "",
        isValidBlackList: 0,
        // 购物条件 - 累计完成订单笔数
        orderCompleteLimitCount: "", // 最小订单笔数
        orderCompleteMaxCount: "", // 最大订单笔数
        // 购物条件 - 累计完成订单金额
        orderCompleteLimitPayment: "", // 最小订单金额
        orderCompleteMaxPayment: "", // 最大订单金额
        // 购物条件 - 最后一次订单完成时间
        lastOrderCompleteTimeType: 0, // 时间类型: 0-不限, 1-距当前天数范围, 2-指定时间段
        lastOrderCompleteStartDay: "", // 距当前开始天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteEndDay: "", // 距当前结束天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteStartTime: "", // 指定开始时间 (当 lastOrderCompleteTimeType='2' 时)
        lastOrderCompleteEndTime: "", // 指定结束时间 (当 lastOrderCompleteTimeType='2' 时)
      },
      quotas: "", //优惠名额
      sharePic: "https://cdn-image.yucrm.cn/hd/images/xhs-order-share.png",
      ruleDTO: {
        customerPaperwork: "",
        cusTemplateJSON: "",
        plusObject: 0,
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "https://cdn-image.yucrm.cn/hd/images/xhs-order-share.png",
        goShopSetting: 0, //进店设置
        goShopAppId: "", //小程序appId
        goShopUrl: "", //小程序页面路径
        displaySequence: 0, //展示排序
        displayNum: "", //展示数量
        showProductType: 0, //晒单条件
        orderStartTime: "",
        orderEndTime: "",
        orderPaymentType: 1,
        filterType: 0,
        itemLimitCount: "",
        orderPaymentLimit: "",
        orderType: 1,
        activityType: 0, //活动类型
        skuIdList: [],
        venderIds: [],
        sellerSkuList: [],
        filterSkuType: 0,
        remindToCheck: 0,
        remindDayNum: "",
        weekendNotRemind: false,
        mergeOrder: false
      },
      specifiedGoods: [], //指定商品
      activityStartTime: null,
      activityEndTime: null,
      templateJson: {
        templateUItype: "",
      },
      levelList: [],
      isDraft: false,
      pickerOption: {
        disabledDate: (time) => {
          //  在活动开始-结束时间范围内
          return (
            time.getTime() < new Date(this.activityStartTime).getTime() ||
            time.getTime() >
              new Date(this.activityEndTime).getTime() - 24 * 60 * 60 * 1000
          );
        },
      },
      orderEndPickerOptions: {
        disabledDate: (time) => {
          // 下单结束时间不可大于活动结束时间
          return time.getTime() > new Date(this.activityEndTime).getTime();
        },
      },
    };
  },
  computed: {
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    isStartEdit() {
      return this.activityData.isStart;
    },
    backgroundImage() {
      return this.ruleDTO.cusTemplateJSON
        ? JSON.parse(this.ruleDTO.cusTemplateJSON).activityBgImg
        : this.templateObj.url;
    },
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    commonPrizeList() {
      return this.ruleDTO.activityType == 0
        ? this.lotteryPrizeList
        : this.claimPrizeList;
    },
    venderId() {
      // 店铺Id
      return this.$store.getters.loginUserInfo.venderId;
    },
    isVenderType() {
      return this.multiShopGoods.some((item) => item.venderType);
    },
    isPop() {
      return this.multiShopGoods.every((item) => !item.venderType);
    },
  },
  watch: {
    // 只选pop店铺
    // isPop(newVal) {
    //   if (newVal) {
    //     this.ruleDTO.orderPaymentType = 0;
    //   } else {
    //     this.ruleDTO.orderPaymentType = 1;
    //   }
    // },
    //自营和pop店铺其中一个或只有自营
    isVenderType(newVal) {
      if (newVal) {
        this.ruleDTO.orderPaymentType = 1;
      } 
      // else {
      //   this.ruleDTO.orderPaymentType = 0;
      // }
    },
    // shopList 由 page-header 异步拉取后 commit 进 store，
    // mounted 阶段 initData 拿到的可能是空数组快照，导致 isVenderType 误判为 false。
    // 此处监听 store.shopList 变化，待其加载完成后按当前已选 venderIds 重新派生 multiShopGoods。
    "$store.state.shopList"(newList) {
      if (newList && newList.length) {
        this.multiShopGoods = useValidateMultiShopGoods(
          this,
          this.ruleDTO.venderIds
        );
      }
    },
  },
  created() {
    if (this.venderType) {
      this.ruleDTO.orderPaymentType = 1;
    }
    this.ruleDTO.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleDTO.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
  },
  mounted() {
    this.initData();
    this.getLevel();
    this.buriedPoint(1, "小红书晒单礼", "互动管理", "互动活动");
  },

  methods: {
    viewMergeLogic() {
      window.open("https://www.yuque.com/yunduanxincrm/mrkpcq/mub1q6wafxefavp4?singleDoc#");
    },
    viewStatisticsLogic() {
      window.open("https://www.yuque.com/yunduanxincrm/mrkpcq/ribmlurbi01iznn8?singleDoc#");
    },
    changeRemind(val) {
      if(val) {
        this.ruleDTO.remindDayNum = 2;
      } else {
        this.ruleDTO.remindDayNum = "";
      }
      this.ruleDTO.weekendNotRemind = false;
    },
    initData() {
      this.ruleDTO.venderIds = [this.venderId];
      this.ruleDTO.sellerSkuList = [
        {
          venderId: this.venderId,
          skuIds: [],
          itemList: [],
        },
      ];
      this.multiShopGoods = useValidateMultiShopGoods(this, [this.venderId]);
    },
    resetMemberFn(val) {
      this.peopleSelected = [];
      this.ruleForm.partner = ["-1"];
      this.ruleForm.firstOpenCardTimeType = 0;
      this.ruleForm.openCardBeforeDay = "";
      this.ruleForm.orderCompleteLimitCount = "";
      this.ruleForm.orderCompleteMaxCount = "";
      this.ruleForm.orderCompleteLimitPayment = "";
      this.ruleForm.orderCompleteMaxPayment = "";
      this.ruleForm.lastOrderCompleteTimeType = 0;
      this.ruleForm.lastOrderCompleteStartDay = "";
      this.ruleForm.lastOrderCompleteEndDay = "";
      this.ruleForm.lastOrderCompleteStartTime = "";
      this.ruleForm.lastOrderCompleteEndTime = "";
      this.ruleDTO.plusObject = 0;
    },
    handleShowNum(val) {
      const num = parseInt(val, 10);
      if (isNaN(num)) return "";
      if (num <= 0) return 1;
      if (num > 20) return 20;
      return num;
    },
    addPrize() {
      if (this.claimPrizeList.length >= this.maxPrizeCount) {
        this.$message.warning(`最多只能添加${this.maxPrizeCount}个奖项`);
        return;
      }
      this.claimPrizeList.push({
        assetsId: null, // 资产项id(计划id优惠卷id商品id)
        prizeType: 0,
        price: null,
        logo: null,
        title: "",
        totalAmount: null,
        singleAmount: "",
      });
    },

    addSettingList() {
      this.lotteryPrizeList.push({
        prizeType: null,
        price: null,
        title: "",
        totalAmount: null,
        percentage: null,
        logo: "",
        prizeObjectType: 0,
      });
    },
    selectGoodsClose(data) {
      if (data) {
        let selectGoodsArr = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          selectGoodsArr.push(fomeVaule);
        });
        this.specifiedGoods = selectGoodsArr;
        this.ruleDTO.skuIdList = selectGoodsArr.map((item) => item.skuId);
      }
      this.isShowGoods = false;
    },
    activityTypeChange(val) {
      this.lotteryPrizeList = [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: null,
          price: null,
          title: "",
          totalAmount: null,
          percentage: null,
          logo: "",
          prizeObjectType: 0,
        },
      ];
      this.claimPrizeList = [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          singleAmount: "",
          prizeObjectType: 0,
        },
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          singleAmount: "",
          prizeObjectType: 0,
        },
      ];
    },
    // 清空下单时间
    clearOrderTime() {
      this.ruleDTO.orderStartTime = null;
      this.ruleDTO.orderEndTime = null;
    },
    exposureProducts() {
      this.isShowGoods = true;
      if (this.specifiedGoods.length == 0) {
        this.specifiedGoods = [];
      }
    },
    filterTypeChange() {
      this.specifiedGoods = [];
      this.ruleDTO.skuIdList = [];
      this.ruleForm.filterSkuType = 0;
    },
    // 深拷贝
    deepCopy(obj) {
      var result = Array.isArray(obj) ? [] : {};
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (typeof obj[key] === "object" && obj[key] !== null) {
            result[key] = this.deepCopy(obj[key]); //递归复制
          } else {
            result[key] = obj[key];
          }
        }
      }
      return result;
    },
    editContentFn(row, index) {
      this.isShowDialog = true;
      this.isEdit = true;
      this.editData = this.deepCopy(row);
      this.currentIndex = index;
    },
    saveForm(row) {
      if (this.shareContentList.length > 20 && !this.isEdit) {
        this.$message.info("添加内容超出20个，请重新编辑");
        return;
      }
      // 保存晒单设置
      row.contentList.forEach((item, index) => {
        let obj = {
          shareContentSource: row.shareContentSource,
          ...Object.assign({}, item), // 合并所有对象
        };
        if (!this.valueRow || !this.valueRow.id) {
          delete obj.id;
        }
        if (!this.isEdit) {
          this.shareContentList.push(obj);
        } else {
          this.shareContentList.splice(this.currentIndex, 1, obj);
        }
      });
    },
    addContent() {
      this.isEdit = false;
      this.editData = null;
      this.isShowDialog = true;
    },
    onShopSetChange(value) {
      this.ruleDTO.goShopAppId = "";
      this.ruleDTO.goShopUrl = "";
    },
    handleInput(val) {
      return val.replace(/[^\d]/g, "");
    },

    //判断尺寸方法 默认200*200
    imgchecked(file, width = 200, height = 200) {
      let _this = this;
      return new Promise((resolve, reject) => {
        let type = file.name
          .substring(file.name.lastIndexOf("."))
          .toLowerCase();
        let sorts = [".png", ".jpg"];
        if (sorts.indexOf(type) < 0) {
          reject();
          this.$message.info("所选图片格式不符，请重新选择");
        } else {
          let image = new Image();
          let _URL = window.URL || window.webkitURL;
          image.onload = function () {
            const valid = image.width == width && image.height == height;
            file.isFlag = valid;
            if (valid) {
              resolve(true);
            } else {
              _this.$message.info("图片尺寸不符合要求，请重新上传");
              reject();
            }
          };
          image.src = _URL.createObjectURL(file);
        }
      });
    },
    // 背景图上传校验
    async beforeUploadUI(file, type) {
      // let sizeype = {
      //   1: {
      //     width: 388,
      //     height: 102,
      //   },
      //   2: {
      //     width: 180,
      //     height: 200,
      //   },
      //   3: {
      //     width: 172,
      //     height: 102,
      //   },
      //   4: {
      //     width: 710,
      //     height: 218,
      //   },
      //   5: {
      //     width: 212,
      //     height: 102,
      //   },
      // };
      // const status = await this.imgchecked(
      //   file,
      //   sizeype[type].width,
      //   sizeype[type].height
      // );
      // if (!status) {
      //   return false;
      // }
      return false;
    },
    // 背景图上传图片
    handleUploadUI(res, type) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        if (type == 1) {
          this.customerPaperwork.url2 = res.data;
          this.$message.success("按钮背景图上传成功");
        }
      }
    },
    initCustomizeData(row) {
      const configJson = row.configJson ? JSON.parse(row.configJson) : {};
      this.customerPaperwork.titleColor = row.rgb || "#ffffff";
      this.customerPaperwork.btnColor = row.rgb2;
      this.customerPaperwork.textColor = row.rgb3;
      this.customerPaperwork.prizeBgColor = configJson.rgb4 || "#ffffff";
      this.currrentRgb = row.rgb;
      this.currrentRgb2 = row.rgb2;
      this.currrentRgb3 = row.rgb3;
      this.currrentRgb4 = configJson.rgb4 || "#ffffff";
    },
    selectTemplate(index, id, item) {
      this.templateObj = item;
      this.templateId = id;
      this.templateJson.templateUItype = index;
      this.initCustomizeData(item);
    },

    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      this.getPolite();
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: "",
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.loading = false;
      this.giftList =
        data.records && data.records.length > 0
          ? data.records.map((item) => {
              return {
                ...item,
                days: item.activityStartTime
                  ? this.getDaysBetween(
                      item.activityStartTime,
                      item.activityEndTime
                    )
                  : "",
              };
            })
          : [];
      if (!this.templateId && this.giftList.length > 0) {
        let obj = this.giftList[0];
        this.templateObj = obj;
        this.templateId = obj.id;
        this.templateJson.templateUItype = 0;
        this.initCustomizeData(this.templateObj);
      } else if (this.templateId) {
        let arr = this.giftList.filter((item) => item.id == this.templateId);
        this.templateObj = arr[0];
        this.templateId = this.templateId;
        this.currrentRgb = this.templateObj.rgb;
        this.currrentRgb2 = this.templateObj.rgb2;
        this.currrentRgb3 = this.templateObj.rgb3;
      }
      this.pageData.total = data.total * 1;
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
          this.getDetail();
        })
        .catch((res) => {});
    },
    //生成规则
    generateRule() {
      const goodsType = {
        0: "任意",
        1: "指定",
        2: "排除",
      };
      let text1 = `下单参与：在${this.ruleDTO.orderStartTime}~${
          this.ruleDTO.orderEndTime
        }期间下单付款店铺${goodsType[this.ruleDTO.filterType]}商品大于等于${
          this.ruleDTO.itemLimitCount
        }件，且订单金额：大于等于${
          this.ruleDTO.orderPaymentLimit
        }元；且订单状态为已完成；`,
        text2 =
          "晒单方式：点击【一键分享小红书】前往小红书发布内容，复制分享得内容链接，返回活动页，粘贴至【上传小红书笔记链接】并提交链接即可等待审核结果；",
        text3 = "抽奖时间：审核完成后，在活动结束之前均可仅需一次抽奖",
        text4 = "",
        shopText="下单店铺："+this.multiShopGoods.map((item) => item.shopTitle).join("、"),
        secondText = "【活动参与规则】",
        thirdText = "【活动奖品】",
        fourthText = "【注意事项】";
      if (this.ruleDTO.activityType == 1) {
        text3 = "领奖时间：审核完成后，在活动结束之前均可领取一个奖品";
      }
      const textArr = [text2, text3];
      if (this.ruleDTO.showProductType == 1) {
        textArr.unshift(text1);
      }
      if(this.ruleDTO.showProductType==1) {
        textArr.push(shopText);
      }
      // 奖品
      const commonPrize = {
        0: "lotteryPrizeList",
        1: "claimPrizeList",
      };
      const prizeList = this[commonPrize[this.ruleDTO.activityType]];
      if (prizeList.length > 0) {
        prizeList.forEach((item, index) => {
          text4 += `奖品${index + 1}：${item.title}，共 ${
            item.totalAmount + "份"
          }${
            item.prizeType == 3 || item.prizeType == 14
              ? "，单份奖品价值" + item.price + "元"
              : ""
          }；\n`;
        });
      }
      text4 += `所有奖品数量有限，先到先得，送完即止。`;
      const { firstText, precautions } = this.getCommonText(
        this.levelList,
        this.ruleForm,
        this.ruleDTO,
        this.actMember
      );
      let Arr1 = [
        firstText,
        [secondText, ...textArr],
        [thirdText, text4],
        [fourthText, precautions],
      ];
      let newText = "";
      const objIndex = {
        0: "\n一、",
        1: "\n二、",
        2: "\n三、",
        3: "\n四、",
      };
      Arr1.forEach((item, index) => {
        let newNum = 0;
        item.forEach((row, it) => {
          if (row.length > 0) {
            if (it != 0) {
              newText = `${newText}${
                index == 2 && this.ruleDTO.couponEnabled ? "" : newNum
              }${index == 2 && this.ruleDTO.couponEnabled ? "" : "."}${row}\n`;
            } else {
              if (index != 0) {
                newText = newText + objIndex[index] + row + "\n";
              } else {
                newText = newText + row + "\n";
              }
            }
            newNum = newNum + 1;
          }
        });
      });
      this.ruleForm.ruleDescription = newText.trim();
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
    },

    // 下一步
    resetForm() {
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      //活动对象限制
      if (
        this.actMember == 2 &&
        (!this.ruleForm.partner || this.ruleForm.partner.length == 0)
      ) {
        this.$message.warning("请选择活动对象");
        return;
      }
      if (this.actMember == 3 && !this.peopleSelected.length) {
        this.$message.warning("请选择指定人群");
        return;
      }

      // 1.14迭代 这里判断 指定入会时间
      if (this.actMember == "2") {
        if (
          this.ruleForm.firstOpenCardTimeType == 1 &&
          !this.ruleForm.openCardBeforeDay
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
        if (
          this.ruleForm.firstOpenCardTimeType == 2 &&
          (!this.ruleDTO.openCardStartTime || !this.ruleDTO.openCardEndTime)
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
        // 最后一次订单完成时间
        if (
          this.ruleForm.lastOrderCompleteTimeType == 1 &&
          !this.ruleForm.lastOrderCompleteEndDay &&
          !this.ruleForm.lastOrderCompleteStartDay
        ) {
          return this.$message.warning("最后一次订单完成时间");
        }

        if (
          this.ruleForm.lastOrderCompleteTimeType == 2 &&
          !this.ruleForm.lastOrderCompleteStartTime &&
          !this.ruleForm.lastOrderCompleteEndTime
        ) {
          return this.$message.warning("最后一次订单完成时间");
        }
      }
      if (this.shareContentList.length == 0) {
        return this.$message.warning("请添加晒单内容");
      }
      if (this.ruleDTO.displaySequence == 1 && !this.ruleDTO.displayNum) {
        return this.$message.warning("请输入展示数量");
      }
      if (this.ruleDTO.showProductType == 1) {
        if (!this.ruleDTO.orderStartTime && !this.ruleDTO.orderEndTime) {
          return this.$message.warning("请选择下单时间");
        }
        if (
          this.ruleDTO.filterType != 0 &&
          this.ruleDTO.sellerSkuList.length > 0
        ) {
          let isTrue = false;
          this.ruleDTO.sellerSkuList.some((item) => {
            if (item.skuIds.length == 0) {
              isTrue = true;
            }
          });
          if (isTrue) {
            const filterType = {
              1: "指定",
              2: "排除",
            };
            this.$message.warning(
              `请选择${filterType[this.ruleDTO.filterType]}商品`
            );
            return;
          }
        }
        // if (!this.ruleDTO.itemLimitCount) {
        //   return this.$message.warning("请输入商品件数");
        // }
        if (!this.ruleDTO.orderPaymentLimit) {
          return this.$message.warning("请输入订单金额");
        }
      }
      const list =
        this.ruleDTO.activityType == 0
          ? this.lotteryPrizeList
          : this.claimPrizeList;
      if (list.length == 0) {
        return this.$message.warning("请添加奖品");
      }
      let flag = false;
      if (this.ruleDTO.activityType == 1) {
        flag = list.some((item) => !item.prizeType || !item.totalAmount);
      } else {
        flag = list.some(
          (item) => !item.prizeType || !item.totalAmount || !item.percentage
        );
      }

      if (flag) {
        return this.$message.warning("请完善奖品信息");
      }

      // 提醒时间必填
      if (this.ruleDTO.remindToCheck==1 && !this.ruleDTO.remindDayNum) {
        return this.$message.warning("请输入提醒时间");
      }

      if (!this.templateId) {
        return this.$message.warning("请选择活动模板");
      }
      // 公活动配置校验
      if (!useValidateMoreActSet(this)) {
        return;
      }
      // 小程序分享标题
      if (!this.ruleDTO.shareTitle) {
        this.$message.warning("请输入小程序分享标题");
        return;
      }
      // 小程序分享简介
      if (!this.ruleDTO.shareIntroduce) {
        this.$message.warning("请输入小程序分享简介");
        return;
      }
      if (!this.ruleForm.ruleDescription) {
        this.$message.warning("请输入活动规则");
        return;
      }
      //新增进店设置校验
      if (this.ruleDTO.goShopSetting == 1 && !this.ruleDTO.goShopAppId) {
        this.$message.warning("请输入小程序appId");
        return;
      }
      if (this.ruleDTO.goShopSetting == 2) {
        if (!this.ruleDTO.goShopUrl) {
          this.$message.warning("请输入指定链接");
          return;
        } else if (
          !this.ruleDTO.goShopUrl.startsWith("https://") ||
          !this.ruleDTO.goShopUrl.includes("jd.com")
        ) {
          this.$message.warning(
            "输入的内容非链接或为接口无法支持的链接，请重新设置"
          );
          return;
        }
      }
      if (this.ruleForm.isExposureItem && this.itemListFor.length == 0) {
        this.$message.warning("请选择曝光商品");
        return;
      }
      if (this.placementPosition.length == 0) {
        this.$message.warning("请选择活动投放位置！");
        return;
      }
      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      // 奖品必选
      const prizeList =
        this.ruleDTO.activityType == 0
          ? this.lotteryPrizeList
          : this.claimPrizeList;
      if (prizeList.some((item) => !item.prizeType)) {
        this.$message.warning("请至少选择一个奖品");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    async handleDialogCloseAnoth() {
      let ruleDTO = {
        ...this.ruleDTO,
        openCardFollow: this.ruleForm.openCardFollow,
        firstOpenCardTimeType: this.ruleForm.firstOpenCardTimeType,
        openCardBeforeDay: this.ruleForm.openCardBeforeDay,
        isForceRemind: this.isForceRemind,
        shareContentList: this.shareContentList,
        multiShopSkuType: this.multiShopSkuType,
        skuBelongVenderId: this.multiShopSkuType==0 && this.itemListFor.length>0 ? this.itemListFor[0].belongVenderId : "",
      };
      ruleDTO.sellerSkuList.forEach((item) => {
        delete item.itemList;
      });
      let obj = {
        ...this.ruleForm,
        subType: 80,
        ruleDTO,
        pointActivityPrizeDTOList: [],
        isKeyActivity: this.isKeyActivity,
        placementPosition: this.placementPosition.join(","),
        isValidBlackList: this.ruleForm.isValidBlackList,
      };
      obj.condFollow = Number(this.ruleForm.condFollow);
      obj.ruleDTO.openCardStartTime =
        this.actMember == 2 ? this.ruleDTO.openCardStartTime : "";
      obj.ruleDTO.openCardEndTime =
        this.actMember == 2 ? this.ruleDTO.openCardEndTime : "";
      obj.ruleDTO.plusObject = this.ruleDTO.plusObject;
      // 其他活动页配置
      obj.ruleDTO.customerPaperwork = JSON.stringify(this.customerPaperwork);

      //曝光商品集合设置
      obj.priceType = 0;
      obj.isExposureItem = this.ruleForm.isExposureItem ? 1 : 0;
      obj.itemList = this.itemListFor;

      // 模板
      obj.templateJson = this.templateJson;
      obj.templateId = this.templateId;

      // 活动对象处理
      // 参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
      obj.allowLevel =
        this.ruleForm.partner && this.ruleForm.partner.length
          ? this.ruleForm.partner.join(",")
          : "";

      if (this.actMember == 1) {
        obj.allowLevel = "-1";
      } else if (this.actMember == 3) {
        obj.allowLevel = "99";
        obj.crowdIds = this.peopleSelected.join(",");
      } else if (this.actMember == 2) {
        obj.allowLevel =
          this.ruleForm.partner && this.ruleForm.partner.length
            ? this.ruleForm.partner.join(",")
            : "";
        if (obj.allowLevel == "-1") {
          //会员等级设置
          let list = ["-1", "0"];
          this.levelList.forEach((item, index) => {
            let num = index + 1;
            list.push(num);
          });
          obj.allowLevel = list.join(",");
        }
      }
      obj.ruleDTO.orderCompleteLimitCount =
        this.ruleForm.orderCompleteLimitCount;
      obj.ruleDTO.orderCompleteMaxCount = this.ruleForm.orderCompleteMaxCount;
      obj.ruleDTO.orderCompleteLimitPayment =
        this.ruleForm.orderCompleteLimitPayment;
      obj.ruleDTO.orderCompleteMaxPayment =
        this.ruleForm.orderCompleteMaxPayment;
      obj.ruleDTO.lastOrderCompleteTimeType =
        this.ruleForm.lastOrderCompleteTimeType;
      if (obj.ruleDTO.lastOrderCompleteTimeType == 1) {
        obj.ruleDTO.lastOrderCompleteStartDay =
          this.ruleForm.lastOrderCompleteStartDay;
        obj.ruleDTO.lastOrderCompleteEndDay =
          this.ruleForm.lastOrderCompleteEndDay;
      } else if (obj.ruleDTO.lastOrderCompleteTimeType == 2) {
        obj.ruleDTO.lastOrderCompleteStartTime =
          this.ruleForm.lastOrderCompleteStartTime;
        obj.ruleDTO.lastOrderCompleteEndTime =
          this.ruleForm.lastOrderCompleteEndTime;
      }
      delete obj.partner;
      delete obj.openCardFollow;
      delete obj.firstOpenCardTimeType;
      delete obj.openCardBeforeDay;
      delete obj.orderCompleteLimitCount;
      delete obj.orderCompleteMaxCount;
      delete obj.orderCompleteLimitPayment;
      delete obj.orderCompleteMaxPayment;
      delete obj.lastOrderCompleteTimeType;
      delete obj.lastOrderCompleteStartDay;
      delete obj.lastOrderCompleteEndDay;
      delete obj.lastOrderCompleteStartTime;
      delete obj.lastOrderCompleteEndTime;
      // 奖品处理
      let prizeListCommon = [];
      if (this.ruleDTO.activityType == 0) {
        prizeListCommon = this.lotteryPrizeList;
      } else {
        prizeListCommon = this.claimPrizeList;
      }
      obj.pointActivityPrizeDTOList = prizeListCommon;
      if (this.checked == true || this.isDraft) {
        this.saveLoading = true;
        if (this.activityData.isStart) {
          let params = {
            activityId: this.valueRow.id,
            ruleDescription: obj.ruleDescription,
            prizes: prizeListCommon
              .filter((item) => item.id)
              .map((item) => {
                return {
                  ...item,
                  prizeId: item.id,
                };
              }),
            isExposureItem: this.ruleForm.isExposureItem ? 1 : 0, //曝光商品
            itemList: this.ruleForm.isExposureItem ? this.itemListFor : [],
            activityName: obj.activityName,
            condFollow: obj.condFollow ? 1 : 0,
            ruleDto: obj.ruleDTO,
            templateId: this.templateId,
            endTime: this.ruleForm.endTime,
            isValidBlackList: obj.isValidBlackList,
            windowSkuList: obj.windowSkuList,
          };
          updateCommon(params)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                this.joinBlackList = false;
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
                this.$message.success("修改成功");
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
              this.saveLoading = false;
            });
        } else {
          if (this.isDraft) {
            obj.status = 5;
            delete obj.templateJson;
          } else {
            // 保存正式活动不需要status
            if (obj.status) delete obj.status;
            if (!this.activityData.isCopy) {
              // 未开始活动修改
              if (this.valueRow && this.valueRow.id) {
                obj.pointActivityId = this.valueRow.id;
                obj.id = this.valueRow.id;
              }
            } else {
              delete obj.templateJson;
            }
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            obj.id = this.valueRow.id;
            // 草稿箱不需要传 pointActivityId
            if (obj.pointActivityId) delete obj.pointActivityId;
          }
          saveOrUpdateXhsShowProduct(obj)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                if (this.isDraft) {
                  this.$message.success("保存成功！");
                  this.$emit("returnBack", true);
                } else {
                  this.joinBlackList = false;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
              this.saveLoading = false;
            });
        }
      } else {
        this.saveLoading = false;
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      if (this.valueRow && this.valueRow.id) {
        this.loading = true;
        getXhsShowProductDetail({ id: this.valueRow.id })
          .then((res) => {
            this.isCreated = true;
            const {
              activityName,
              startTime,
              endTime,
              ruleDto,
              isExposureItem,
              ruleDescription,
              allowLevel,
              crowdIds,
              condFollow,
              templateId,
              isKeyActivity,
              placementPosition,
              isValidBlackList,
              studentSatus,
            } = res.data;
            const {
              openCardFollow,
              firstOpenCardTimeType,
              openCardBeforeDay,
              isForceRemind,
              shareContentList,
              multiShopSkuType, 
              skuBelongVenderId,
              sellerSkuList,
              venderIds,
              filterSkuType,
              mergeOrder
            } = ruleDto;
            this.ruleForm.activityName =
              activityName + (this.activityData.isCopy ? "复制" : "");
            this.ruleForm.condFollow = condFollow ? true : false;
            this.multiShopSkuType = multiShopSkuType || 0;
            this.skuBelongVenderId = skuBelongVenderId || "";
            // 活动对象配置
            if (allowLevel == "99") {
              this.peopleSelected = crowdIds.split(",");
              this.actMember = "3";
            } else if (allowLevel == "-1") {
              this.actMember = "1";
              this.ruleForm.partner = ["-1"];
            } else {
              this.actMember = "2";
              if (allowLevel.indexOf("-1") != -1) {
                this.ruleForm.partner = ["-1"];
              } else {
                this.ruleForm.partner = allowLevel.split(",");
              }
            }
            this.ruleForm.openCardFollow = openCardFollow;
            this.ruleForm.isValidBlackList = isValidBlackList;
            this.ruleForm.firstOpenCardTimeType = firstOpenCardTimeType;
            this.ruleForm.openCardBeforeDay = openCardBeforeDay;
            this.ruleDTO = ruleDto;
            this.ruleDTO.mergeOrder = mergeOrder || false;
            this.isForceRemind = isForceRemind;
            this.isKeyActivity = isKeyActivity || 0;
            this.placementPosition = placementPosition
              ? placementPosition.split(",")
              : ["SHOP"];
            // 学生身份
            this.ruleForm.studentSatus = studentSatus || "";
            this.ruleForm.orderCompleteLimitCount =
              ruleDto.orderCompleteLimitCount;
            this.ruleForm.orderCompleteMaxCount = ruleDto.orderCompleteMaxCount;
            this.ruleForm.orderCompleteLimitPayment =
              ruleDto.orderCompleteLimitPayment;
            this.ruleForm.orderCompleteMaxPayment =
              ruleDto.orderCompleteMaxPayment;
            this.ruleForm.lastOrderCompleteTimeType =
              ruleDto.lastOrderCompleteTimeType || 0;
            this.ruleForm.lastOrderCompleteStartDay =
              ruleDto.lastOrderCompleteStartDay;
            this.ruleForm.lastOrderCompleteEndDay =
              ruleDto.lastOrderCompleteEndDay;
            this.ruleForm.lastOrderCompleteStartTime =
              ruleDto.lastOrderCompleteStartTime;
            this.ruleForm.lastOrderCompleteEndTime =
              ruleDto.lastOrderCompleteEndTime;
            if (ruleDto.customerPaperwork) {
              this.customerPaperwork = JSON.parse(ruleDto.customerPaperwork);
            }
            this.shareContentList = shareContentList || [];
            // 指定商品回显
            this.ruleDTO.sellerSkuList = sellerSkuList&&sellerSkuList.length>0 ? sellerSkuList : [{
              skuIds: ruleDto.skuIdList,
              venderId: this.venderId,
            }];
            this.ruleDTO.venderIds = venderIds&&venderIds.length>0 ? venderIds : [this.venderId];
            if (this.activityData.isCopy||this.isDraftEdit) {
              // 跨店复制
              if(this.ruleDTO.venderIds.length>0) {
                let index = this.ruleDTO.venderIds.findIndex((item)=>{
                  return item == this.venderId
                })
                if(index==-1) {
                  this.ruleDTO.venderIds.unshift(Number(this.venderId))
                  this.ruleDTO.sellerSkuList.unshift({
                    venderId: Number(this.venderId),
                    skuIds: [],
                    itemList: [],
                  })
                }
              }
            }
            this.multiShopGoods = useValidateMultiShopGoods(this,this.ruleDTO.venderIds);
            this.ruleDTO.filterSkuType = filterSkuType || 0;
            // if (ruleDto.showProductType == 1 && ruleDto.filterType != 0) {
            //   getTaobaoItemListSku({
            //     current: 1,
            //     size: ruleDto.skuIdList.length,
            //     skuIds: ruleDto.skuIdList,
            //   }).then((res) => {
            //     this.specifiedGoods = res.data.records;
            //   });
            // }
            this.templateJson = JSON.parse(res.data.templateJson);
            // v2.5 => 复制不需要回显奖品和规则
            if (!this.activityData.isCopy) {
              this.ruleForm.startTime = startTime;
              this.ruleForm.endTime = endTime;
              this.activityStartTime = startTime;
              this.activityEndTime = endTime;

              this.ruleForm.isExposureItem = isExposureItem ? true : false;
              this.itemListFor = res.data.itemList;
              this.ruleForm.ruleDescription = ruleDescription;
              const prizeType = {
                0: "lotteryPrizeList",
                1: "claimPrizeList",
              };
              this[prizeType[this.ruleDTO.activityType]] =
                res.data.pointActivityPrizeDTOList;
            }
            if (this.activityData.isCopy) {
              this.ruleForm.ruleDescription = "";
            }
            this.templateId = templateId;
            this.getPolite();
          })
          .catch((res) => {});
      } else {
        this.activityStartTime = this.$getDate(30)[0];
        this.activityEndTime = this.$getDate(30)[1];
        this.hdTaskTemplateGroup();
      }
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.localStepNum = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.game-givetips {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
}
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 28px 28px 1px 24px;
    margin-bottom: 29px;
  }
  .upload-box {
    width: 500px;
    padding: 20px;
    background: #f4f6fa;
    border-radius: 4px 4px 4px 4px;
  }
  .remind-box {
    width: 750px;
    padding: 20px;
    background: #f4f6fa;
    border-radius: 4px 4px 4px 4px;
  }
  .buttonGroup {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #666;
  }

  .bg-wrap {
    width: 80px;
    // overflow: hidden;
    &-img {
      width: 100%;
      height: auto;
      object-fit: cover;
    }
  }

  .invite-box {
    position: relative;
    background-color: #f7f8fa;
    padding: 16px;
    border-radius: 8px;
    .label-style {
      display: inline-block;
      text-align: right;
      flex-shrink: 0;
    }
    .goods-content {
      width: 95%;
    }
    .move-btn {
      position: absolute;
      top: 16px;
      right: 16px;
    }
  }

  .ml12 {
    margin-left: 12px;
  }

  .ml8 {
    margin-left: 8px;
  }
  .mr8 {
    margin-right: 8px;
  }

  .ml20 {
    margin-left: 20px;
  }

  .mlr8 {
    margin: 0 8px;
  }

  .w90 {
    width: 90px;
  }
  .w125 {
    width: 125px;
  }
  .w150 {
    width: 150px;
  }
  .w180 {
    width: 180px;
  }
  .w400 {
    width: 400px;
  }

  .tip-color {
    color: #666;
  }

  .logo-style {
    margin-top: 8px;
    width: 80px;
    height: 80px;
  }

  .text-red {
    color: #ff4d4f;
  }
  .size-tip {
    color: #aaaaaa;
    margin-left: 8px;
  }
  .btn_boxs {
    background-color: rgb(248, 249, 252);
    padding: 16px;
    border-radius: 4px;
    width: 500px;
  }
  .limit {
    display: flex;
    align-items: center;
    color: #333333;
  }
  .label-color {
    color: #333333;
  }

  .copywriting {
    display: flex;
    flex-direction: column;
  }

  .goods-box {
    display: flex;
    align-items: center;
    padding: 10px;
    img {
      width: 60px;
      height: 60px;
    }
  }
  .order-box {
    margin-top: 16px;
    padding: 16px;
    background: #fafafa;
    border-radius: 4px;
  }
}
.flex-c {
  display: flex;
  flex-direction: column;
}
/deep/ .el-tooltip__popper {
  font-size: 14px !important;
}
</style>
